import { createSelector } from "@reduxjs/toolkit";

const selectFeed = (state)=> state.feed;


export const selectDataId = createSelector(selectFeed,feed => feed.dataId)
export const selectCurrentCategoryId = createSelector(selectFeed,feed => feed.currentCategoryId)
export const selectIsTweetsFetching = createSelector(selectFeed,feed => feed.tweetsFetching)
export const selectStates = createSelector(selectFeed,feed => feed.states)
export const selectLocalities = createSelector(selectFeed,feed => feed.localities)
export const selectUserTweets = createSelector(selectFeed,feed => feed.tweets)
export const selectIsLikedTweetsFetching = createSelector(selectFeed,feed => feed.likedTweetFetching)
export const selectUserLikedTweets = createSelector(selectFeed,feed => feed.likedTweets)
export const selectUserMediaTweets = createSelector(selectFeed,feed => feed.mediaTweets)